import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Play, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { TranslatedText } from '@/components/TranslatedText';

export const HeroMediaSlideshow = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="py-12 sm:py-20 px-4 bg-gradient-to-b from-background to-muted/20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mx-auto text-center"
      >
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/5 border border-primary/15 mb-6">
          <Play className="w-3.5 h-3.5 text-primary" />
          <span className="text-xs font-medium text-primary">
            <TranslatedText>Platform Preview</TranslatedText>
          </span>
        </div>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-4">
          <TranslatedText>Preview Inside the Academy</TranslatedText>
        </h2>

        <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-3 px-2">
          <TranslatedText>
            We want you to see what to expect. That's why we let you access one of our 500+ classes completely free — no credit card required.
          </TranslatedText>
        </p>

        <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-8 px-2">
          <TranslatedText>
            Test it. See if you like the way we teach. You're free to leave after that 1 class — but we'd love for you to stay and subscribe.
          </TranslatedText>
        </p>

        <Link to="/apply?plan=free">
          <Button
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground h-14 px-8 text-base font-semibold rounded-xl active:scale-[0.98] shadow-lg"
          >
            <Play className="w-5 h-5 mr-2" />
            <TranslatedText>Watch 1 FREE Class</TranslatedText>
          </Button>
        </Link>

        <div className="flex items-center justify-center gap-1.5 mt-4 text-muted-foreground">
          <Shield className="w-3.5 h-3.5" />
          <span className="text-xs">
            <TranslatedText>No credit card required</TranslatedText>
          </span>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroMediaSlideshow;
